// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uRcl","input":"styles_input__295K7"};